export default __webpack_public_path__ + "static/media/two_arrows.92ad817d.svg";